export const environment = {
  appName: 'BIOMAF',
  production: false,
	version: 'dev',
  api: {
    baseUrl: 'https://biomaf.dev.irevolution-group.com/api',
  },
  featureFlags: {
    enableItems: true,
  }
} as const;
